import React, { useState, useEffect } from "react";
import {
  Formik,
  FieldArray,
  Field,
  useFormikContext,
  ErrorMessage,
} from "formik";
import { PlusIcon as PlusIcon } from "@heroicons/react/24/solid";
import { TrashIcon as TrashIconMini } from "@heroicons/react/20/solid";
import _ from "lodash";
import PractionerSearchNSelect from "./PractionerSearchNSelect";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import AppButton from "../../../../shared/AppButton";

function CareTeam({}) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = useFormikContext();
  const addData = (values) => {
    let data = _.cloneDeep(values);
    // createInsurancePlan({ variables: { input: data } });
  };

  useEffect(() => {
    if (!values.careTeamsArr || values.careTeamsArr.length === 0) {
      setFieldValue("careTeamsArr", [
        {
          practitioner: "",
          practitionerName: "",
          practitioner_role: "",
          care_team_role: "Primary Provider",
          qualification: "",
        },
      ]);
    }
  }, [values.careTeamsArr, setFieldValue]);
  const { t, i18n } = useTranslation();
  const tableHeaders = [
    {
      name: t("Practitioner"),
    },
    // {
    //   name: "Practitioner Role",
    // },
    {
      name: t("Care Team Role"),
    },
    {
      name: t("Qualification"),
    },
    {
      name: "",
    },
  ];

  const practionerRoles = [
    { id: "Doctor", name: "Doctor" },
    { id: "Nurse", name: "Nurse" },
    { id: "Pharmacist", name: "Pharmacist" },
    { id: "Researcher", name: "Researcher" },
    { id: "Teacher/educator", name: "Teacher/educator" },
    { id: "Dentist", name: "Dentist" },
    { id: "Physiotherapist", name: "Physiotherapist" },
    { id: "SpeechTherapist", name: "SpeechTherapist" },
    { id: "ICT professional", name: "ICT professional" },
  ];

  const careTeamRoles = [
    { id: "Primary Provider", name: t("Primary Provider") },
    { id: "Assisting Provider", name: t("Assisting Provider") },
    { id: "Supervising Provider", name: t("Supervising Provider") },
    { id: "Other Provider", name: t("Other Provider") },
  ];

  const qualifications = [
    {
      id: 1,
      name: "Qualification 1",
    },
    {
      id: 2,
      name: "Qualification 2",
    },
  ];

  const removeItem = (index) => {
    const updatedArr = [...values.careTeamsArr];
    updatedArr.splice(index, 1);
    setFieldValue("careTeamsArr", updatedArr);
  };

  return (
    <div class="care_teams !p-3" id="careTeams1">
      <FieldArray name="careTeamsArr">
        {({ push, remove }) => {
          return (
            <>
              <div class="flex_cont !mb-2">
                <div class="personal-title">
                  <div class="inventory-svg">
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 34 34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="34" height="34" rx="8" fill="#F4F6F8"></rect>
                      <path
                        d="M9.25 11H11.25V14H21.25V11H23.25V16H25.25V11C25.25 9.9 24.35 9 23.25 9H19.07C18.65 7.84 17.55 7 16.25 7C14.95 7 13.85 7.84 13.43 9H9.25C8.15 9 7.25 9.9 7.25 11V25C7.25 26.1 8.15 27 9.25 27H15.25V25H9.25V11ZM16.25 9C16.8 9 17.25 9.45 17.25 10C17.25 10.55 16.8 11 16.25 11C15.7 11 15.25 10.55 15.25 10C15.25 9.45 15.7 9 16.25 9Z"
                        fill="#0070C2"
                      ></path>
                      <path
                        d="M25.25 17.5L19.76 23L16.75 20L15.25 21.5L19.76 26L26.75 19L25.25 17.5Z"
                        fill="#0070C2"
                      ></path>
                    </svg>
                  </div>
                  <div class="personal-head">
                    <span>{t("Care Team *")}</span>
                  </div>
                </div>
                <div>
                  <AppButton
                    label={t("Add Care Team")}
                    onClick={() =>
                      push({
                        practitioner: "",
                        practitionerName: "",
                        practitioner_role: "",
                        care_team_role: "Primary Provider",
                        qualification: "",
                      })
                    }
                    startIcon={<AddIcon />}
                  />
                </div>
              </div>
              <div class="pre_auth_communication_table">
                <div className="">
                  <div className="" id="tableBody">
                    {values.careTeamsArr.map((item, index) => {
                      return (
                        <div
                          key={"addressform"}
                          className="personal-data !p-2 !mb-2 last:!mb-0 relative"
                        >
                          <div className=" grid grid-cols-1 md:grid-cols-3 gap-1.5 ">
                            <div className="flex flex-col justify-between h-full w-full">
                              <div className="flex flex-nowrap items-center gap-1 mb-0.5 w-full overflow-hidden">
                                <label className="font-semibold text-[12px] text-gray-700 capitalize shrink-0">
                                  {t("Practitioner")}
                                </label>
                                {values.careTeamsArr?.[index]
                                  ?.practitionerName && (
                                  <div className="min-w-0 flex-1 overflow-hidden">
                                    <Tooltip
                                      title={
                                        values.careTeamsArr[index]
                                          .practitionerName
                                      }
                                      arrow
                                    >
                                      <span
                                        className="text-xs text-gray-700 font-semibold cursor-default block"
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        (
                                        {
                                          values.careTeamsArr[index]
                                            .practitionerName
                                        }
                                        )
                                      </span>
                                    </Tooltip>
                                </div>
                                )}
                              </div>
                              <div>
                                <PractionerSearchNSelect
                                  setFieldValue={(val) => {
                                    setFieldValue(
                                      `careTeamsArr.${index}.practitioner`,
                                      val.id,
                                    );
                                    setFieldValue(
                                      `careTeamsArr.${index}.practitionerName`,
                                      val.name,
                                    );
                                    setFieldValue(
                                      `careTeamsArr.${index}.practitioner_role`,
                                      val.Role,
                                    );
                                    setFieldValue(
                                      `careTeamsArr.${index}.qualification`,
                                      `${val.Speciality}`,
                                    );
                                  }}
                                />
                                <ErrorMessage
                                  name={`careTeamsArr.${index}.practitioner`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>
                            <div className="flex flex-col justify-between h-full w-full">
                              <label className="font-semibold text-[12px] text-gray-700 mb-0.5 capitalize shrink-0">
                                {t("Care Team Role")}
                              </label>
                              <div>
                                <Field
                                  className="insurance-plans-select"
                                  as="select"
                                  name={`careTeamsArr.${index}.care_team_role placeholder:!text-xs !text-xs !text-gray-700`}
                                >
                                  <option value="font-semibold">
                                    <p>{t("Please Select")}</p>
                                  </option>
                                  {careTeamRoles.map((item) => {
                                    return (
                                      <option value={item.name} key={item.name}>
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                </Field>
                                <ErrorMessage
                                  name={`careTeamsArr.${index}.care_team_role`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>
                            <div className="flex flex-col justify-between h-full w-full">
                              <label className="font-semibold text-[12px] text-gray-700 mb-0.5 capitalize shrink-0">
                                {t("Qualification")}
                              </label>
                              <div>
                                <Field
                                  className="insurance-plans-select"
                                  placeholder={t("Qualifications")}
                                  type="text"
                                  disabled
                                  name={`careTeamsArr.${index}.qualification placeholder:!text-xs !text-xs font-semibold`}
                                />
                                <ErrorMessage
                                  name={`careTeamsArr.${index}.qualification`}
                                  component="div"
                                  className="text-red-500 text-xs"
                                />
                              </div>
                            </div>
                            {values.careTeamsArr.length > 1 && (
                              <div className="absolute cursor-pointer top-0 right-0">
                                <div
                                  className=""
                                  class="remove-row"
                                  onClick={() => remove(index)}
                                >
                                  <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 38 38"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="19"
                                      cy="19"
                                      r="19"
                                      fill="#fee2e2"
                                    />
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M26 20H12C11.448 20 11 19.553 11 19C11 18.447 11.448 18 12 18H26C26.553 18 27 18.447 27 19C27 19.553 26.553 20 26 20Z"
                                      fill="#dc2626"
                                    />
                                    <mask
                                      id="mask0_235_11306"
                                      style={{
                                        WebkitMaskType: "luminance",
                                        maskType: "luminance",
                                      }}
                                      maskUnits="userSpaceOnUse"
                                      x="11"
                                      y="18"
                                      width="16"
                                      height="2"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M26 20H12C11.448 20 11 19.553 11 19C11 18.447 11.448 18 12 18H26C26.553 18 27 18.447 27 19C27 19.553 26.553 20 26 20Z"
                                        fill="#dc2626"
                                      />
                                    </mask>
                                    <g mask="url(#mask0_235_11306)"></g>
                                  </svg>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </FieldArray>

      {errors.careTeamsArr &&
      touched.careTeamsArr &&
      typeof errors.careTeamsArr === "string" ? (
        <div className="max-w-2xl mt-2 text-sm leading-6">
          <p className="text-red-500">{errors.careTeamsArr}</p>
        </div>
      ) : null}
    </div>
  );
}

export default CareTeam;
